<script setup lang="ts">
import MainLayout from 'views/layouts/MainLayout.vue'
import Loading from 'vue-loading-overlay';
import LastComments from 'components/BellaCloud/LastComments.vue'
</script>

<template>
    <MainLayout>
        <div class="slot-body">
            <div class="block--gray">
                <div class="container">
                    <div class="row pt-3">
                        <div class="col-lg-6 pt-4">
                            <h1 class="title">{{ translate.titleTopsPage }}</h1>
                        </div>
                        <div class="col-lg-6 pt-2 d-flex align-items-center">
                            <span class="subtitle">{{ translate.subTitle }}</span>
                        </div>
                    </div>
                    <hr class="mb-3">
                </div>
                <!-- Top Albums -->
            </div>
            <!-- Comentarios -->
            <div>
                <LastComments :translate="translate" v-if="!isMobile()" />
            </div>
            <div class="pb-5">
                <div class="container mb-5">
                    <loading v-model:active="loadingTopAlbum" :is-full-page="false" color="#b20000" height="200" />
                    <div class="row pt-3">
                        <div v-for="item in listTop" class="col-lg-3 mt-5" :key="item.id">
                            <div class="d-flex flex-row align-items-center justify-content-center block-gray flex-wrap"
                                @click="goLink('BellaCloudAlbumPage', { albumId: item.id, nameAlbum: item.url, locale, titleHeader: 'Top Albuns' })">
                                <div class="photos d-flex flex-row align-items-center justify-content-center flex-wrap pt-3"
                                    :ref="'img-' + item.id">
                                </div>
                                <div class="col-12 text-center mt-2">
                                    <span class="name-pastas">{{ item.name }}</span>
                                </div>
                                <font-awesome-icon :icon="['fas', 'user']"
                                    style="font-size: 10px; margin-inline-end: 5px;" />
                                {{ translate.by }}
                                {{ item.user.name }}
                            </div>
                        </div>
                    </div>
                </div>
                <vue-awesome-paginate v-if="paginationOther.data.length" :modelValue="paginationOther.current_page"
                    :total-items="paginationOther.total" :items-per-page="paginationOther.per_page" :max-pages-shown="3"
                    :on-click="onClickHandler" />
            </div>
        </div>
    </MainLayout>
</template>

<script lang="ts">
import { mapState } from 'pinia'
import { defineComponent } from 'vue'
import { localeStore } from 'stores/locale'
import tradutor from 'tradutors/bellacloud'
import api from '../../api'
import { userStore } from '../../stores/user';
import router from '../../router';
import { isMobile } from 'views/shared/utils/mobile'

export default defineComponent({
    name: 'ContactUsView',
    computed: {
        ...mapState(localeStore, ['locale']),
        ...mapState(userStore, ['isLoggedIn']),
        translate: function () {
            if (this.locale === 'pt-br') {
                return tradutor.portugues
            } else {
                return tradutor.ingles
            }
        }
    },
    head() {
        return {
            templateParams: {
        subTitle: null, 
                subPage: this.translate.titleTopsPage,
                page_url: window.location.origin + this.$route.fullPath,
                page_description: this.locale == 'pt-br' ?
                    `O Bella Cloud é um lugar onde você armazena as fotos e vídeos do Bella da Semana que mais gosta. Nele é possível criar álbuns privados, ou compartilhados com seus amigos e outros usuários.` :
                    `Bella Cloud is a place where you store the photos and videos of the Bella Club you like best. It is possible to create private albums, or shared with your friends and other users.`,
                page_image: '/favicon.ico',
                page_keywords: 'bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site',
                page_locale: this.locale,
                page_url_pt: "https://belladasemana.com.br/pt-br/bellacloud/top",
                page_url_en: "https://belladasemana.com.br/en/bellacloud/top",
                page_canonical: "https://belladasemana.com.br"+this.$route.fullPath,                
            }
        }
    },
    data() {
        return {
            list: [],
            listTop: [],
            paginationOther: {
                current_page: 1,
                total: 1,
                per_page: 1,
                data: []
            },
            loadingMyAlbum: true,
            loadingTopAlbum: true,
            loadingOtherAlbum: true
        }
    },
    created() {
        const lang = ['pt-br', 'en']
        if (lang.indexOf(this.$route.params.locale) === -1) {
            window.location.replace('/')
        }
        this.getTopAlbums()
    },

    watch: {
        'locale': function () {
            this.getTopAlbums()
        }
    },
    methods: {
        async getTopAlbums(page = '') {
            this.loadingTopAlbum = true
            api.get(`v1/bellacloud/getTopList?locale=${this.locale}&page=${page}`).then(({ data }) => {
                this.paginationOther = data
                this.listTop = this.paginationOther.data

                this.generateHtmlImg()
            }).finally(() => this.loadingTopAlbum = false)
        },
        async generateHtmlImg() {
            this.listTop.map(item => {
                this.getAlbumImages(item.id, 'img-' + item.id)
            })
        },
        async onClickHandler(page: number) {
            await this.getTopAlbums(page)
        },
        async getAlbumImages(id, nameRef) {
            api.get(`v1/bellacloud/getAlbumImages/${id}?locale=${this.locale}`).then(({ data }) => {
                let img = ""
                data.map(item => {
                    img += `<img class="thumb-pastas col-6" src="${item}" alt="${nameRef}">`
                })

                this.$refs[nameRef][0].innerHTML = img
            })
        },
        goLink(name, params = null) {
            router.push({ name, params, query: { q: this.translate.titleTopsPage } })
        }
    }
})
</script>

<style lang="css" scoped>
.slot-body {
    margin-top: 65px !important;    
    background-color: #fff !important;
}

.container {
    min-height: 65px;
}

.wellcome {
    font-size: 24px;
    font-weight: bold;
    line-height: 15px;
    color: #000000;
    font-family: "Roboto";
}


.title {
    font-family: 'Bebas-Neue-Light';
    color: #000000;
    font-size: 64px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 77px;
}

.name-pastas {
    color: #b20000;
    font-family: 'Roboto-Medium';
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 19px;
    text-align: center;
}

.subtitle {
    color: #5b5858;
    font-family: 'Roboto-Medium';
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
}

.block-gray {
    border-radius: 8px;
    padding: 15px;
    min-height: 296px;
    /* background-image: url('../../assets/img/icone-pasta-bellacloud.svg'); */
    background-image: url('../../assets/img/icone-bella-cloud-2.svg');
    background-repeat: no-repeat;
    background-size: cover;
    cursor: pointer;
}

.photos {
    width: 100%;
    min-height: 200px;
}

hr {
    height: 2px;
    opacity: 0.1;
    transform: scaleY(-1);
    background-color: #000000;
}

.link-login {
    font-size: 18px;
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
}


/* regras mobile 769vp */
@media screen and (max-width: 769px) {
    .subtitle {
        color: #b20000;
    }
}
</style>

<style lang="css">
.thumb-pastas {
    box-sizing: border-box;
    height: 87px;
    width: 87px;
    border: 1px solid #979797;
    background-color: #D8D8D8;
    border-radius: 5px;
    margin: 5px;
    object-fit: cover;
    object-position: center top;
}

.routes span {
    color: #999999;
    font-family: "Roboto-Regular";
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
}
</style>
